import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { TranslateModule } from '@ngx-translate/core';
import { ThemeService } from '@services/theme.service';

@Component({
  selector: 'app-footer',
  templateUrl: 'footer.component.html',
  styleUrls: ['./footer.component.scss'],
  imports: [CommonModule, TranslateModule],
  standalone: true
})

export class FooterComponent implements OnInit {

  theme!: any;
  selectedLang!: string;

  constructor(private themeService: ThemeService, private translate: TranslateService){
    this.themeService.getCurrentTheme().subscribe(theme => {
      this.theme = theme;
    });
  }
  ngOnInit() { }
}
